import React from 'react';
import style from '../../flightRequest/flightRequest.module.scss';
import { Row } from 'acscp/components/common/row';
import { AcmiFlightStartEndDates } from 'acscp/components/legs/acmiFlightStartEndDates';
import { FormattedMessage } from 'react-intl';
import { AcmiFlightPlan } from 'acscp/components/legs/flightPlan/acmiFlightPlan';
import { BookingLeg } from 'acscp/store/legModels';

interface AcmiFlightTrackRowProps {
    legs: BookingLeg[];
    quoteCount: number | null;
}

export class AcmiFlightTrackRow extends React.Component<AcmiFlightTrackRowProps> {
    render(): JSX.Element {
        return (
            <>
                <Row className={style.FlightStartEndDates}>
                    <AcmiFlightStartEndDates legs={this.props.legs}/>
                    {this.props.quoteCount !== null &&
                        <div className={style.Count}>
                            <span className={style.LabelLarge}>
                                <FormattedMessage
                                    id={'components.flightRequest.offersAvailable'}
                                    defaultMessage={'OFFERS AVAILABLE'}
                                />{': '}
                            </span>
                            <span className={style.LabelMedium}>
                                <FormattedMessage
                                    id={'components.flightRequest.offers'}
                                    defaultMessage={'OFFERS'}
                                />:
                            </span>
                            <span>{this.props.quoteCount}</span>
                        </div>
                    }
                </Row>
                <Row className={style.DisplayFlex}>
                    <AcmiFlightPlan base={this.props.legs[0].departureLocation}/>
                    {this.props.quoteCount !== null && <div className={style.Count}/>}
                </Row>
            </>
        );
    }
}
